import React, {Component} from 'react';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';

const DataCard = (props) => (
    <Card style={{marginTop: 15}}>
        <CardHeader
            title={props.cardTitle}
            subtitle={props.cardSubtitle}
            actAsExpander={true}
            showExpandableButton={true}
        />
        <CardText expandable={true}>
            {props.inner}
        </CardText>
        <CardActions expandable={true}>
            {props.actions}
        </CardActions>
    </Card>
);

export default DataCard;


/** WEBPACK FOOTER **
 ** ./app-react/components/DataCard.jsx
 **/